export function getReportedOrderItemId(item) {
    return item?.qualityCheckItemId;
}
